// extracted by mini-css-extract-plugin
module.exports = {"content":"_2RRL8WDwYB-X6sblByBbnU","icon":"_3cNAOIyTO2MltREUvrEFvg"};